type DataLayerWindow = Window & { dataLayer?: unknown[] };

/** Returns the GTM dataLayer if present and well-shaped, otherwise `null`. Does not create one. */
export function getDataLayer(): unknown[] | null {
  const dl = (window as DataLayerWindow).dataLayer;
  return Array.isArray(dl) ? dl : null;
}

/** Returns the GTM dataLayer, creating an empty array on `window` if missing. */
export function getOrCreateDataLayer(): unknown[] {
  const w = window as DataLayerWindow;
  w.dataLayer ??= [];
  return w.dataLayer;
}

/** @internal — test-only reset of the GTM dataLayer on `window`. */
export function _resetDataLayer() {
  delete (window as DataLayerWindow).dataLayer;
}
